export const INVESTOR_OFFER_REQUEST = "INVESTOR_OFFER_REQUEST";
export const INVESTOR_OFFER_SUBMIT = "INVESTOR_OFFER_SUBMIT";
export const INVESTOR_QUESTIONNAIRE = "INVESTOR_QUESTIONNAIRE";
export const INVESTOR_QUESTIONNAIRE_RESET = "INVESTOR_QUESTIONNARE_RESET";
export const INVESTOR_ANALYTIC = "INVESTOR_ANALYTIC";
